//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: "other_form_list",
        data(){
            return{
                a:1,
                listData: [],
                isWrite:{//判断是否已经填写表单
                    bbFormE:'',
                    bbFormD:'',
                    maternalFormA:''
                },
                id: this.$route.query.id,
                tabVal: this.$route.query.tabVal
            }
        },
        methods:{
            //查询固定表单是否填写
            getNewForm(typeNum){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id,
                    form_type:typeNum
                }
                 Api.otherFormApi.getFormStatus(params).then ( res => {
                    this.$vux.loading.hide()
                    console.info("是否填过此表单",res)
                    if(typeNum=='10'){
                        if(res.errcode==200){
                            this.isWrite.maternalFormA=res.data.id
                        }else{
                            this.isWrite.maternalFormA=''
                        }
                    }
                    if(typeNum=='11'){
                        if(res.errcode==200){
                            this.isWrite.bbFormE=res.data.id
                        }else{
                            this.isWrite.bbFormE=''
                        }
                    }
                    if(typeNum=='12'){
                        if(res.errcode==200){
                            this.isWrite.bbFormD=res.data.id
                        }else{
                            this.isWrite.bbFormD=''
                        }
                    }
                 })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d + ' '+ h + ':' + minute + ':' + second
            },
            apiOtherFormList(){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                console.info(params)
                Api.monthLiveApi.otherFormList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        for(let item of res.data.list){
                            let time= ''
                            if(item.create_time != '0'){
                                time = this.formatDateTime(item.create_time)
                            }
                            let obj ={
                                create_time: time,
                                id:item.id,
                                name:item.name,
                                user_name:item.user_name
                            }
                            this.listData.push(obj)
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //查看表格
            writeForm(form_id){
                let marternal_id = this.$route.query.id
                this.$router.push({
                    path: './detail_other_form',
                    query: {
                        id: marternal_id,
                        form_id: form_id
                    }
                })
            },
            toForm(form_id){
                console.info(form_id)
                switch(form_id){
                    case '11':
                        this.$router.push({
                            path:'/bb_form_e', 
                            query: {
                                id: this.$route.query.id
                            }
                        })
                    break
                    case '10':
                        this.$router.push({
                            path:'/maternal_form_a',
                            query: {
                                id: this.$route.query.id
                            }
                        })
                    break 
                    case '12':
                        this.$router.push({
                            path:'/bb_form_d',
                            query: {
                                id:this.$route.query.id,

                            }
                        })
                    break 
                }
            },
            toFormDetail(type,formId){
                switch(type){
                    case '11':
                        this.$router.push({
                            path:'/bb_form_e_detail', 
                            query: {
                                id: this.$route.query.id,
                                form_id: formId
                            }
                        })
                    break
                    case '10':
                        this.$router.push({
                            path:'/maternal_form_a_detail',
                            query: {
                                id: this.$route.query.id,
                                form_id: formId
                            }
                        })
                    break 
                    case '12':
                        this.$router.push({
                            path:'/bb_form_d_detail',
                            query: {
                                id: this.$route.query.id,
                                form_id: formId
                            }
                        })
                    break 
                }
            }
        },
        created(){
            this.getNewForm('10')
            this.getNewForm('11')
            this.getNewForm('12')
        },
        mounted (){
            this.apiOtherFormList()
        }
    }



// WEBPACK FOOTER //
// ./src/components/other_form_list.vue